import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/onSite/suggestedQuotations';
import {
  REQUEST_FETCH_SUGGESTED_QUOTATIONS,
  SUCCESS_FETCH_SUGGESTED_QUOTATIONS,
  FAIL_FETCH_SUGGESTED_QUOTATIONS,
  REQUEST_UPDATE_SUGGESTED_QUOTATION,
  SUCCESS_UPDATE_SUGGESTED_QUOTATION,
  FAIL_UPDATE_SUGGESTED_QUOTATION,
} from '../../../../actions/entities/player';

const initialSuggestedQuotationsState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt } = action;
    return {
        ...state,
        id: id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success: true,
            error: false
        }
    };
}

function successUpdate(state, action) {
  const { payload, receivedAt } = action;
  return {
    ...state,
    info: {
      ...state.info,
      isFetching: false,
      lastPayload: payload,
      needRefresh: false,
      updatedAt: receivedAt,
      success: true,
      error: false
    }
  };
}

function fail(state, action) {
    const { error, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialSuggestedQuotationsState, {
    [REQUEST_FETCH_SUGGESTED_QUOTATIONS]: request,
    [SUCCESS_FETCH_SUGGESTED_QUOTATIONS]: success,
    [FAIL_FETCH_SUGGESTED_QUOTATIONS]: fail,

    [REQUEST_UPDATE_SUGGESTED_QUOTATION]: request,
    [SUCCESS_UPDATE_SUGGESTED_QUOTATION]: successUpdate,
    [FAIL_UPDATE_SUGGESTED_QUOTATION]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/suggestedQuotations/index.js